export default __webpack_public_path__ + "static/media/atraso-upgas.1b3957b3.mp3";